// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Storefront24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Storefront24CircleFilled: FC<Storefront24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm9.025-9v-7.95a3.95 3.95 0 0 0 .888-1.375c.208-.533.212-1.125.012-1.775l-1.05-3.4a2.326 2.326 0 0 0-.725-1.088A1.79 1.79 0 0 0 22.975 7h-13.9c-.45 0-.846.142-1.187.425A2.21 2.21 0 0 0 7.175 8.5l-1.05 3.4c-.2.65-.196 1.25.013 1.8.208.55.504 1 .887 1.35V23c0 .55.196 1.02.588 1.413.391.391.862.587 1.412.587h14c.55 0 1.02-.196 1.413-.587.391-.392.587-.863.587-1.413Zm-5.775-9.463c-.233.309-.575.463-1.025.463-.333 0-.617-.13-.85-.387a1.317 1.317 0 0 1-.35-.913V9h1.95l.55 3.5c.05.383-.042.73-.275 1.037Zm-4.588.075c-.241.259-.554.388-.937.388s-.696-.15-.938-.45c-.241-.3-.329-.65-.262-1.05l.55-3.5h1.95v3.7c0 .35-.12.654-.363.913Zm-4.6.063a1.1 1.1 0 0 1-.787.325c-.483 0-.83-.192-1.037-.575-.209-.383-.263-.742-.163-1.075l1-3.35h1.95l-.55 3.85c-.05.333-.188.608-.412.825Zm13.763-.25c-.217.383-.567.575-1.05.575a1.1 1.1 0 0 1-.787-.325 1.398 1.398 0 0 1-.413-.825L21.025 9h1.9l1.05 3.35c.117.333.067.692-.15 1.075Zm-.8 9.575h-14v-7.05c.05.033.096.05.138.05h.112c.433 0 .82-.07 1.162-.213.342-.141.688-.387 1.038-.737.3.3.646.533 1.037.7.392.167.83.25 1.313.25a2.95 2.95 0 0 0 1.213-.25c.374-.167.704-.4.987-.7.3.3.646.533 1.038.7.391.167.812.25 1.262.25.433 0 .842-.083 1.225-.25.383-.167.725-.4 1.025-.7.333.333.67.575 1.012.725.342.15.738.225 1.188.225h.088c.024 0 .079-.017.162-.05V23Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Storefront24CircleFilled;
